import { Paper } from "@mui/material";
import styled from "styled-components";

import Menu from "./sidebar components/Menu";

const Wrapper = styled(Paper)`
  display: flex;
  flex-direction: column;
  transition: 0.2s ease;
  border-radius: 0;
  box-shadow: 5px 0 5px -5px rgba(35, 37, 38, 0.15);
`;

export default function Sidebar({
  sidebarState,
  onMouseEnter,
  onMouseLeave,
  selectedMenu,
  setSelectedMenu,
}) {
  return (
    <Wrapper
      elevation={0}
      style={{
        width: sidebarState.open ? "255px" : "80px",
        background: "#fff",
      }}
    >
      <Menu
        sidebarState={sidebarState}
        selectedMenu={selectedMenu}
        setSelectedMenu={setSelectedMenu}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </Wrapper>
  );
}
